<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('appointment_matrix')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{$formatDateTime(header.Created_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Created_By}}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{$formatDateTime(header.Edited_Date)}}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{header.Edited_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button :icon="mode == this.$FORM_MODE_DELETE ? 'pi pi-trash' : 'pi pi-save' " :label="mode == this.$FORM_MODE_DELETE ? 'Delete' : 'Save' " :class="mode == this.$FORM_MODE_DELETE ? 'p-button-danger' : 'p-button-success' " @click="confirm($event)" :disabled="isDeleted" v-if="mode != this.$FORM_MODE_VIEW"/>
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm">
                    <div class="p-fluid">
                        <div class="field grid">
                            <label for="Warehouse_Code" class="col-2">{{$t('warehouse')}}</label>
                            <div class="col-4 md-4">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Warehouse_Code" :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{  }" v-if="header" :disabled="!canEdit" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>

                        <div class="field grid">
                            <label for="Valid_From" class="col-2">{{$t('valid_from')}}</label>
                            <div class="col-4 md-4">
                                <DatePicker dateFormat="dd/mm/yy" :showTime="false" inputMask="99/99/9999" momentFormat="dd/mm/YYYY" class="p-column-filter p-inputtext-sm" v-model="header.Valid_From" v-if="header" :disabled="!canEdit" />
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>

                        <div class="field grid">
                            <label for="Valid_To" class="col-2">{{$t('valid_to')}}</label>
                            <div class="col-4 md-4">
                                <DatePicker momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy" :showTime="false" inputMask="99/99/9999" class="p-column-filter p-inputtext-sm" v-model="header.Valid_To" v-if="header" :disabled="!canEdit"/>
                                <Skeleton v-else-if="!header" />
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                       <div class="col-4">
                            <Fieldset :legend="$t('product_category')" :toggleable="true">
                                <DataTable :loading="!header" v-if="header" :value="header.ProductCategories ? header.ProductCategories : null" responsiveLayout="scroll"  class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                                    <Column style="width:30px">
                                        <template #header="">
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" :disabled="!canEdit || header.Is_Deleted"  />
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="!canEdit"/>
                                        </template>
                                    </Column>
                                    <Column field="Business_Segment_Id" :header="$t('product_category')" key="Business_Segment_Id" >
                                        <template #body="slotProps">
                                            <div class="p-fluid">
                                                <CustomSelect v-model="slotProps.data[slotProps.column.props.field]" :url="this.$API_URL + 'list/business_segment'" :minLength="0" :params="{ exclude_ids: excludeProductCategories }"  @change="editDetail(slotProps)" :disabled="!canEdit"/>
                                            </div>
                                        </template>  
                                    </Column>
                                </DataTable>
                                
                            </Fieldset>
                        </div>
                        <div class="col-8">
                            <Fieldset :legend="$t('appointment_schedule')" :toggleable="true">
                                <DataTable :loading="!header" v-if="header" :value="header.Schedules ? header.Schedules : null" responsiveLayout="scroll"  class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                                    <Column style="width:30px">
                                        <template #header="">
                                            <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addSchedule"   :disabled="!canEdit || header.Is_Deleted"/>
                                        </template>
                                        <template #body="slotProps">
                                            <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteSchedule(slotProps)" :disabled="!canEdit"/>
                                        </template>
                                    </Column>
                                    <Column field="Slot_Name" :header="$t('slot_name')" key="Driver_Id" class="w-2">
                                        <template #body="slotProps">
                                            <InputText name="Slot_Name" type="text" v-model="slotProps.data[slotProps.column.props.field]" @input="editSchedule(slotProps)" :disabled="!canEdit" /> 
                                        </template>  
                                    </Column>
                                    <Column field="Time_From" :header="$t('time_from')" >
                                        <template #body="slotProps">
                                            <DatePicker hourFormat="24"  :showTime="true" :timeOnly="true" momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy"  class="p-inputtext-sm" v-model="slotProps.data[slotProps.column.props.field]" @change="editSchedule(slotProps)" :disabled="!canEdit" />
                                        </template>  
                                    </Column>
                                    <Column field="Time_To" :header="$t('time_to')" >
                                        <template #body="slotProps">
                                            <DatePicker hourFormat="24"  :showTime="true"  momentFormat="DD/MM/YYYY" dateFormat="dd/mm/yy" :timeOnly="true" class="p-inputtext-sm" v-model="slotProps.data[slotProps.column.props.field]"  @change="editSchedule(slotProps)" :disabled="!canEdit"/>
                                        </template>  
                                    </Column>
                                    <Column field="Max_Slot" :header="$t('max_slot')">
                                        <template #body="slotProps">
                                                <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="0" @input="editSchedule(slotProps)"  :disabled="!canEdit"/>
                                        </template>
                                    </Column>
                                </DataTable>
                            </Fieldset>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>

<script>
    export default {
        name: "Editor",
        data() {
            return {
                indexName: "AppointmentMatrixIndex",
                url: this.$API_URL + "appointmentmatrix/",
                header: null,
                detail: null,
                schedule: null,
                productcategory: null,
                mode: "",
                isDeleted: false,
                id: 0,
                formEditable: true,
            }
        },
        methods: {
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.productcategory = response.data.data.product_category;
                        self.schedule = response.data.data.schedule;
                        self.header.mode = self.mode;
                        self.isDeleted = self.header.Is_Deleted;
                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            saveData() {
                var self = this;

                this.$emit('block-ui');
                this.$axios.post(this.url, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.$router.push({ path: "/AppointmentMatrix/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            addDetail() {
                var newDetail = this.productcategory;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };
                this.header.ProductCategories.push(det);
                
            },
            deleteDetail(event) {
                if (event) {
                    var detail = this.header.ProductCategories[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.header.ProductCategories.splice(this.header.ProductCategories.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            addSchedule() {
                var newDetail = this.schedule;
                newDetail.mode = this.$FORM_MODE_CREATE;
                var det = { ...newDetail };
                det.Time_From = new Date();
                det.Time_To = new Date();
                this.header.Schedules.push(det);
                
            },
            deleteSchedule(event) {
                if (event) {
                    var detail = this.header.Schedules[event.index];

                    if (detail.mode == this.$FORM_MODE_CREATE) this.header.Schedules.splice(this.header.Schedules.indexOf(detail), 1);
                    else detail.mode = this.$FORM_MODE_DELETE;
                }
            },
            editSchedule(event) {
                var index = event.index;
                if (this.header.Schedules && this.header.Schedules.length > 0) {
                    let m = this.header.Schedules[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.header.Schedules[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            editDetail(event) {
                var index = event.index;
                if (this.header.ProductCategories && this.header.ProductCategories.length > 0) {
                    let m = this.header.ProductCategories[index].mode;

                    if (m == this.$FORM_MODE_UNCHANGED) {
                        this.header.ProductCategories[index].mode = this.$FORM_MODE_EDIT;
                    }
                }
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;

            this.getData();
        },
        computed:{
            excludeProductCategories(){
                var vehicles = "";
                if(this.header.ProductCategories.length > 0){
                    var allIds = this.header.ProductCategories.map(function(v) {
                        return v.Business_Segment_Id;
                    });
                    vehicles = allIds.join(";");
                }

                return vehicles;
            },
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            },
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            }
        }
    }
</script>